import { __assign } from "tslib";
import * as React from 'react';
import { CnCheckbox as PCCnCheckbox, CnCheckboxGroup as PCCnCheckboxGroup, } from '@cainiaofe/cn-ui';
export var CnCheckbox = function (props) {
    return React.createElement(PCCnCheckbox, __assign({}, props));
};
export var CnCheckboxGroup = function (props) {
    return React.createElement(PCCnCheckboxGroup, __assign({}, props));
};
